import getPopoutUrlKey from './getPopoutUrlKey.js';

const setPopoutUrl = async (name, url) => {
  localStorage.setItem(getPopoutUrlKey(name), url);
};

export default setPopoutUrl;